import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {map, Observable} from 'rxjs';

const ISO_DATETIME_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z?$/;
const DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/;

function transformDates(obj: any): any {
  if (obj === null || obj === undefined || typeof obj !== 'object') return obj;
  if (obj instanceof Date) return obj;
  if (obj instanceof Blob || obj instanceof ArrayBuffer) return obj;
  if (Array.isArray(obj)) return obj.map(transformDates);

  const result: any = {};
  for (const key of Object.keys(obj)) {
    const value = obj[key];
    if (typeof value === 'string' && ISO_DATETIME_REGEX.test(value)) {
      result[key] = new Date(value);
    } else if (typeof value === 'string' && DATE_ONLY_REGEX.test(value)) {
      const [year, month, day] = value.split('-').map(Number);
      result[key] = new Date(year, month - 1, day);
    } else {
      result[key] = transformDates(value);
    }
  }
  return result;
}

export class BlobSafeDateTransformInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.responseType === 'blob' || req.responseType === 'arraybuffer') {
      return next.handle(req);
    }
    return next.handle(req).pipe(
      map(event => {
        if (event instanceof HttpResponse && event.body) {
          return event.clone({body: transformDates(event.body)});
        }
        return event;
      })
    );
  }
}
